module.exports = __webpack_public_path__ + "img/materia_prima.56ed8459.jpg";